import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

interface LogAuditoria {
  id: string;
  timestamp: string;
  vendaId: string;
  evento: string;
  usuario: string;
  tipo: 'upload' | 'extracao' | 'aprovacao' | 'reprovacao' | 'regra' | 'evidencia';
  detalhes: string;
  regraAplicada?: string;
  evidencias?: string[];
}

export default function TrilhaAuditoriaPage() {
  const [filtros, setFiltros] = useState({
    vendaId: '',
    usuario: '',
    tipo: '',
    periodo: '30dias'
  });

  const [logs] = useState<LogAuditoria[]>([
    {
      id: 'LOG-001',
      timestamp: '15/12/2024 14:36:00',
      vendaId: 'VND-2024-001',
      evento: 'Venda recebida',
      usuario: 'Sistema',
      tipo: 'upload',
      detalhes: 'Venda recebida via integração sistêmica do PDV Supermercado Central'
    },
    {
      id: 'LOG-002',
      timestamp: '15/12/2024 14:36:05',
      vendaId: 'VND-2024-001',
      evento: 'Dados extraídos',
      usuario: 'Sistema',
      tipo: 'extracao',
      detalhes: 'Dados extraídos automaticamente do XML da nota fiscal',
      evidencias: ['nfe-12345678.xml']
    },
    {
      id: 'LOG-003',
      timestamp: '15/12/2024 14:36:10',
      vendaId: 'VND-2024-001',
      evento: 'Regra aplicada',
      usuario: 'Sistema',
      tipo: 'regra',
      detalhes: 'Regra "Produtos Elegíveis" aplicada com sucesso',
      regraAplicada: 'REG-001 v3'
    },
    {
      id: 'LOG-004',
      timestamp: '15/12/2024 14:36:15',
      vendaId: 'VND-2024-001',
      evento: 'Venda aprovada',
      usuario: 'João Auditor',
      tipo: 'aprovacao',
      detalhes: 'Venda aprovada após análise manual. Motivo: Todos os critérios atendidos',
      evidencias: ['analise-manual-001.pdf']
    },
    {
      id: 'LOG-005',
      timestamp: '14/12/2024 15:22:30',
      vendaId: 'VND-2024-002',
      evento: 'Venda recebida',
      usuario: 'Sistema',
      tipo: 'upload',
      detalhes: 'Venda recebida via upload manual de cupom fiscal'
    },
    {
      id: 'LOG-006',
      timestamp: '14/12/2024 15:22:45',
      vendaId: 'VND-2024-002',
      evento: 'Dados extraídos',
      usuario: 'Sistema',
      tipo: 'extracao',
      detalhes: 'Dados extraídos via OCR do cupom fiscal digitalizado',
      evidencias: ['cupom-scan-002.jpg']
    },
    {
      id: 'LOG-007',
      timestamp: '14/12/2024 15:23:00',
      vendaId: 'VND-2024-002',
      evento: 'Regra aplicada',
      usuario: 'Sistema',
      tipo: 'regra',
      detalhes: 'Regra "Bloqueio de Duplicidade" aplicada - Alerta gerado',
      regraAplicada: 'REG-006 v2'
    },
    {
      id: 'LOG-008',
      timestamp: '13/12/2024 10:15:20',
      vendaId: 'VND-2024-003',
      evento: 'Venda reprovada',
      usuario: 'Maria Auditora',
      tipo: 'reprovacao',
      detalhes: 'Venda reprovada. Motivo: Produto não elegível para a campanha',
      evidencias: ['justificativa-reprovacao-003.pdf']
    },
    {
      id: 'LOG-009',
      timestamp: '13/12/2024 09:45:10',
      vendaId: 'VND-2024-003',
      evento: 'Evidência anexada',
      usuario: 'Pedro Participante',
      tipo: 'evidencia',
      detalhes: 'Participante anexou documento complementar',
      evidencias: ['documento-complementar-003.pdf']
    },
    {
      id: 'LOG-010',
      timestamp: '12/12/2024 16:30:00',
      vendaId: 'VND-2024-004',
      evento: 'Venda aprovada',
      usuario: 'Sistema',
      tipo: 'aprovacao',
      detalhes: 'Venda aprovada automaticamente - Todas as regras atendidas',
      regraAplicada: 'Aprovação automática'
    }
  ]);

  const getTipoIcon = (tipo: string) => {
    const icons = {
      upload: { icon: 'ri-upload-2-line', color: 'text-blue-600', bg: 'bg-blue-100' },
      extracao: { icon: 'ri-file-search-line', color: 'text-purple-600', bg: 'bg-purple-100' },
      aprovacao: { icon: 'ri-checkbox-circle-line', color: 'text-emerald-600', bg: 'bg-emerald-100' },
      reprovacao: { icon: 'ri-close-circle-line', color: 'text-red-600', bg: 'bg-red-100' },
      regra: { icon: 'ri-shield-check-line', color: 'text-orange-600', bg: 'bg-orange-100' },
      evidencia: { icon: 'ri-file-add-line', color: 'text-teal-600', bg: 'bg-teal-100' }
    };
    return icons[tipo as keyof typeof icons];
  };

  const logsFiltrados = logs.filter(log => {
    if (filtros.vendaId && !log.vendaId.toLowerCase().includes(filtros.vendaId.toLowerCase())) return false;
    if (filtros.usuario && !log.usuario.toLowerCase().includes(filtros.usuario.toLowerCase())) return false;
    if (filtros.tipo && log.tipo !== filtros.tipo) return false;
    return true;
  });

  const exportarLogs = (formato: 'pdf' | 'excel') => {
    console.log(`Exportando logs em formato ${formato}`);
    alert(`Exportação em ${formato.toUpperCase()} iniciada!`);
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Trilha de Auditoria & Compliance</h1>
            <p className="text-sm text-gray-600 mt-1">Histórico completo de todas as ações de auditoria</p>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={() => exportarLogs('pdf')}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-file-pdf-line"></i>
              </div>
              <span>Exportar PDF</span>
            </button>
            <button
              onClick={() => exportarLogs('excel')}
              className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-file-excel-2-line"></i>
              </div>
              <span>Exportar Excel</span>
            </button>
          </div>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">ID da Venda</label>
              <input
                type="text"
                value={filtros.vendaId}
                onChange={(e) => setFiltros({ ...filtros, vendaId: e.target.value })}
                placeholder="Ex: VND-2024-001"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Usuário</label>
              <input
                type="text"
                value={filtros.usuario}
                onChange={(e) => setFiltros({ ...filtros, usuario: e.target.value })}
                placeholder="Nome do usuário"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Evento</label>
              <select
                value={filtros.tipo}
                onChange={(e) => setFiltros({ ...filtros, tipo: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Todos os tipos</option>
                <option value="upload">Upload</option>
                <option value="extracao">Extração</option>
                <option value="aprovacao">Aprovação</option>
                <option value="reprovacao">Reprovação</option>
                <option value="regra">Regra</option>
                <option value="evidencia">Evidência</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Período</label>
              <select
                value={filtros.periodo}
                onChange={(e) => setFiltros({ ...filtros, periodo: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="7dias">Últimos 7 dias</option>
                <option value="30dias">Últimos 30 dias</option>
                <option value="90dias">Últimos 90 dias</option>
                <option value="ano">Último ano</option>
              </select>
            </div>
          </div>
          <div className="mt-4 flex justify-end">
            <button
              onClick={() => setFiltros({ vendaId: '', usuario: '', tipo: '', periodo: '30dias' })}
              className="text-sm text-blue-600 hover:text-blue-800 cursor-pointer whitespace-nowrap"
            >
              Limpar filtros
            </button>
          </div>
        </div>

        {/* Timeline de Logs */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">
            Histórico de Eventos ({logsFiltrados.length})
          </h3>
          <div className="space-y-6">
            {logsFiltrados.map((log, index) => {
              const tipoIcon = getTipoIcon(log.tipo);
              return (
                <div key={log.id} className="relative">
                  {index !== logsFiltrados.length - 1 && (
                    <div className="absolute left-6 top-12 bottom-0 w-0.5 bg-gray-200"></div>
                  )}
                  <div className="flex items-start space-x-4">
                    <div className={`w-12 h-12 rounded-full ${tipoIcon.bg} flex items-center justify-center flex-shrink-0`}>
                      <div className={`w-6 h-6 flex items-center justify-center ${tipoIcon.color}`}>
                        <i className={tipoIcon.icon}></i>
                      </div>
                    </div>
                    <div className="flex-1 bg-gray-50 rounded-lg p-4 border border-gray-200">
                      <div className="flex items-start justify-between mb-2">
                        <div>
                          <h4 className="text-sm font-semibold text-gray-900">{log.evento}</h4>
                          <p className="text-xs text-gray-500 mt-1">
                            {log.timestamp} • {log.usuario} • Venda: {log.vendaId}
                          </p>
                        </div>
                        <span className="text-xs text-gray-500">ID: {log.id}</span>
                      </div>
                      <p className="text-sm text-gray-700 mb-3">{log.detalhes}</p>
                      {log.regraAplicada && (
                        <div className="flex items-center space-x-2 mb-2">
                          <span className="text-xs font-medium text-gray-600">Regra:</span>
                          <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-semibold">
                            {log.regraAplicada}
                          </span>
                        </div>
                      )}
                      {log.evidencias && log.evidencias.length > 0 && (
                        <div className="flex items-center space-x-2 flex-wrap gap-2">
                          <span className="text-xs font-medium text-gray-600">Evidências:</span>
                          {log.evidencias.map((evidencia, idx) => (
                            <button
                              key={idx}
                              className="inline-flex items-center space-x-1 px-2 py-1 bg-white border border-gray-300 rounded text-xs text-gray-700 hover:bg-gray-50 cursor-pointer whitespace-nowrap"
                            >
                              <div className="w-3 h-3 flex items-center justify-center">
                                <i className="ri-attachment-line"></i>
                              </div>
                              <span>{evidencia}</span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Informações de Compliance */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-6">
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shield-check-line text-white"></i>
                </div>
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-emerald-900 mb-2">Auditoria Completa</h4>
                <p className="text-sm text-emerald-800">
                  Todos os eventos são registrados com timestamp, usuário responsável e evidências anexadas para garantir total rastreabilidade.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-file-shield-line text-white"></i>
                </div>
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-blue-900 mb-2">Compliance Fiscal</h4>
                <p className="text-sm text-blue-800">
                  Logs podem ser exportados para auditoria externa e fiscal, garantindo conformidade com regulamentações.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
